import { useState, useEffect } from 'react';
import { listenToCollection } from '../services/firestore.service';
import { where, orderBy } from 'firebase/firestore';

export const useNotifications = (userId) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    // Note: Subcollection path
    const path = `users/${userId}/notifications`;
    
    // We ideally want to order by createdAt desc, but that requires index.
    // For now, just get them and sort client-side if needed, or assume insertion order roughly.
    const unsubscribe = listenToCollection(
      path,
      [], // Add orderBy('createdAt', 'desc') if index exists
      (data) => {
        setNotifications(data);
        const unread = data.filter(n => !n.read).length;
        setUnreadCount(unread);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  const markAsRead = async (notificationId) => {
    // Implementation to mark as read would go here (likely an API call or direct Firestore update if allowed)
    // Since write path is API Gateway, this might need an API service method.
    // For now, we'll just leave it as a placeholder or TODO.
    console.log('Marking as read:', notificationId);
  };

  return { notifications, unreadCount, markAsRead, loading, error };
};

